/* eslint-disable unicorn/prefer-string-replace-all */
export default function placeNameToUrl(locationName: string) {
  return locationName
    .toLowerCase()
    .replace(/[,\s/]+/g, '-') // replace all spaces, commas and slashes with a single dash
    .replace(/-+/g, '-') // replace multiple dashes with a single dash
    .replace(/^-|-$/g, ''); // remove leading and trailing dashes
}
